<template>
  <section>
    <Card :title="$t('CONTACT_MAINTENANCE')" class="card-info">
      <FormRow v-show="roleType != null && canUpdate">
        <RadioGroup v-model="roleType" size="large" slot="a">
          <Radio v-if="userType != null && userType == 'External'" label="External">{{$t('EXTERNAL_USER')}}</Radio>
          <Radio v-if="(userType != null && userType == 'Delta') || isExceptionApplication" label="Delta">{{$t('DELTA_USER')}}</Radio>
        </RadioGroup>
      </FormRow>

      <div v-show="roleType != null && canUpdate">
        <FormRow v-if="roleType == 'External'" :fieldNameArr="[$t('EMAIL')]">
          <Input v-model="email" ref="email" slot="a" />
          <Button type="primary" @click="checkEmail" slot="b">{{$t('CHECK')}}</Button>
        </FormRow>

        <FormRow v-if="roleType == 'Delta'" :fieldNameArr="[$t('AD_ACCOUNT')]">
          <Input v-model="adAccount" ref="adAccount" slot="a" />
          <Button type="primary" @click="checkAD" slot="b">{{$t('CHECK')}}</Button>
        </FormRow>

        <FormRow v-if="readyUpdate" :fieldNameArr="[$t('NAME'), roleType == 'Delta' ? '' : $t('PHONE'), roleType == 'Delta' ? '' : $t('TITLE')]">
          <Input v-model="name" slot="a" :disabled="roleType == 'Delta'" />
          <Input v-model="telephone" ref="telephone" slot="b" v-if="roleType != 'Delta'" />
          <Input v-model="jobTitle" ref="jobTitle" slot="c" v-if="roleType != 'Delta'" />
        </FormRow>

        <FormRow v-if="readyUpdate" :fieldNameArr="[$t('GROUP_ADMIN'), $t('AUTHORIZATION')]">
          <i-switch v-model="groupAdmin" size="large" true-value="Y" false-value="N" slot="a">
            <span slot="open">{{$t('YES')}}</span>
            <span slot="close">{{$t('NO')}}</span>
          </i-switch>
          <CheckboxGroup v-model="roleArr" size="large" slot="b">
            <Checkbox v-for="(role, index) in roleList" :key="index" :label="role.code">{{
              role.name
            }}</Checkbox>
          </CheckboxGroup>
          <Tooltip placement="top" slot="b-pre">
            <Icon type="md-help" :size="24" />
            <div slot="content" style="white-space: normal">
              <List>
                <ListItem v-for="(item, index) in roleList" :key="index">
                  {{ item.code }}
                </ListItem>
              </List>
            </div>
          </Tooltip>
        </FormRow>
        <ButtonRow v-show="readyUpdate && canUpdate">
          <Button type="success" @click="add" slot="0">{{$t('ADD')}}</Button>
          <Button type="warning" @click="modify" slot="1">{{$t('MODIFY')}}</Button>
          <Button type="dashed" @click="reset" slot="2">{{$t('RESET')}}</Button>
        </ButtonRow>
      </div>
      <TablePage
        v-show="existedContact"
        :columnsList="columnsList"
        :resultList="contactList"
        :tableWidth="windowWidth"
        @update="clickRow"
        @changeSelection="changeSelection"
      ></TablePage>
      <ButtonRow v-if="canUpdate">
        <Button type="error" @click="remove" v-if="existedDelete" slot="0">{{$t('COMMON_BUTTON_remove')}}</Button>
        <Button type="primary" @click="contactConfirm" v-if="existedContact" slot="1">{{$t('CONTACT_CONFIRM')}}</Button>
      </ButtonRow>
      <Modal :z-index="modalSize" :reset-drag-position="true" v-model="createExternalUser" sticky :draggable="true" :title="$t('EXTERNAL_USER')" @on-ok="confirmCreateExternalUser">
        <FormRow :fieldNameArr="[$t('EMAIL'), $t('NAME'), $t('PHONE'), $t('TITLE')]">
          <Input v-model="createEmail" slot="a" />
          <Input v-model="createName" slot="b" />
          <Input v-model="createPhone" slot="c" />
          <Input v-model="createJobTitle" slot="d" />
        </FormRow>
      </Modal>
    </Card>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo, AlertDelete } from "@/util/alert"
import { CheckEmail, Translate, ExceptionHandling } from "@/util/common"

import { v4 as uuidv4 } from "uuid"

export default {
  name: "ContactMaintain",
  props: {
    userType: {
      type: String,
      default: null,
    },
    group: {
      type: Object,
      default: () => null,
    },
    isUpdate: {
      type: Boolean,
      default: () => false,
    },
    isExceptionApplication: {
      type: Boolean,
      default: () => false,
    },
  },
  created() {
    let vueInstance = this
    vueInstance.roleType = vueInstance.userType == "External" ? "External" : "Delta"
    vueInstance.$authHttp
      .post(
        "role/search/attribute",
        JSON.stringify({
          attributeDtos: [
            {
              key: "GROUP_PERSON",
              value: "Person",
            },
          ],
          paged: false,
        })
      )
      .then((response) => {
        response.data._embedded.roleResourceList.forEach((role) => {
          vueInstance.roleList.push(role)
          vueInstance.columnsFrontList.push({
            title: role.name,
            render: (h, params) => {
              let value = params.row[role.name] == "Y" ? "V" : ""
              return h("span", {}, value)
            },
            width: 150,
            align: "center",
            notSearch: true,
          })
        })
        if (vueInstance.userType == "External") {
          vueInstance.columnsList = vueInstance.columnsFrontList.concat(vueInstance.columnsNameList, vueInstance.columnsDetailList)
        } else {
          vueInstance.columnsList = vueInstance.columnsFrontList.concat(vueInstance.columnsNameList, [{
            title: this.$t('EMAIL'),
            key: "email",
            width: 150,
            align: "center",
          }])
        }
      })
      .catch(() => {})
    if (vueInstance.isUpdate) {
      searchAccounts(vueInstance)
    }
  },
  data() {
    return {
      user: null,
      azureADSuffix: "@deltaSuppier.com",
      roleList: [],
      uniqueId: null,
      roleType: null,
      name: null,
      userId: null,
      telephone: null,
      email: null,
      username: null,
      adAccount: null,
      jobTitle: null,
      groupAdmin: "N",
      originGroupAdmin: "N",
      roleArr: [],
      originRoleArr: [],
      updateByRowIndex: -1,
      readyUpdate: false,
      columnsList: [],
      contactList: [],
      deltaContactList: [],
      externalContactList: [],
      createExternalUser: false,
      createEmail: "",
      createName: "",
      createPhone: "",
      createJobTitle: "",
      columnsFrontList: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: this.$t('GROUP_ADMIN'),
          render: (h, params) => {
            let value = params.row["groupAdmin"] == "Y" ? "YES" : "NO"
            return h("span", {}, value)
          },
          width: 150,
          align: "center",
          notSearch: true,
        },
      ],
      columnsNameList: [
        {
          title: this.$t('LOGIN_ACCOUNT'),
          key: "username",
          align: "center",
          width: 250,
        },
        {
          title: this.$t('NAME'),
          key: "name",
          width: 150,
        }
      ],
      columnsDetailList: [
        {
          title: this.$t('PHONE'),
          key: "telephone",
          width: 250,
        },
        {
          title: this.$t('TITLE'),
          key: "jobTitle",
          width: 150,
        }
      ],
      selectionList: [],
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getModalSize", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    contactConfirm() {
      this.$emit("contactConfirm")
    },
    checkAD() {
      const vueInstance = this
      vueInstance.toggleLoading(true)
      vueInstance.$vendorHttp
        .get("group-account/emp?account=" + vueInstance.adAccount)
        .then((response) => {
          vueInstance.readyUpdate = true
          vueInstance.user = response.data
          vueInstance.name = response.data.username
          vueInstance.userId = response.data.id
          vueInstance.username = response.data.username
          vueInstance.email = response.data.email
          vueInstance.$vendorHttp
            .get("group-account/emp/" + vueInstance.userId + "/roles")
            .then((response) => {
              vueInstance.toggleLoading(false)
              response.data._embedded.roleResourceList.forEach((role) => {
                if (role.code == "GROUP_ADMIN") {
                  vueInstance.groupAdmin = "Y"
                  vueInstance.originGroupAdmin = "Y"
                }
                vueInstance.roleArr.push(role.code)
              })
            })
            .catch(() => {})
        })
        .catch((error) => {
          if (error.response.status == 444) {
            let text = vueInstance.$buildErrorMessage(error)
            vueInstance.$Swal.fire({
              icon: "error",
              title: Translate("COMMON_MESSAGE_ERROR"),
              text,
            })
          }
        })
    },
    checkEmail() {
      const vueInstance = this
      if (vueInstance.validationEamil() == null) {
       vueInstance.toggleLoading(true)
        vueInstance.$vendorHttp
        .get("group-account/extusr?email=" + vueInstance.email.toUpperCase())
        .then((response) => {
          vueInstance.readyUpdate = true
          vueInstance.user = response.data
          vueInstance.name = response.data.name
          vueInstance.userId = response.data.id
          vueInstance.username = response.data.username
          vueInstance.telephone = response.data.telephone
          vueInstance.jobTitle = response.data.jobTitle
          vueInstance.$vendorHttp
            .get("group-account/extusr/" + vueInstance.userId + "/roles")
            .then((response) => {
              vueInstance.toggleLoading(false)
              response.data._embedded.roleResourceList.forEach((role) => {
                if (role.code == "GroupAdmin") {
                  vueInstance.groupAdmin = "Y"
                  vueInstance.originGroupAdmin = "Y"
                }
                vueInstance.roleArr.push(role.code)
              })
            })
            .catch(() => {})
        })
        .catch((error) => {
          if (error.response.status == 444) {
            let text = vueInstance.$buildErrorMessage(error)
            vueInstance.$Swal
              .fire({
                icon: "info",
                title: Translate("COMMON_MESSAGE_INFO"),
                text,
              })
              .then((result) => {
                vueInstance.createExternalUser = true
                vueInstance.createName = ""
                vueInstance.createPhone = ""
                vueInstance.createJobTitle = ""
                vueInstance.createEmail = vueInstance.email.toUpperCase()
              })
          }
        })
      }
    },
    reset() {
      this.name = null
      this.telephone = null
      this.email = null
      this.username = null
      this.adAccount = null
      this.jobTitle = null
      this.groupAdmin = "N"
      this.originGroupAdmin = "N"
      this.updateByRowIndex = -1
      this.selectionList = []
      this.roleArr = []
      this.originRoleArr = []
    },
    add() {
      let vueInstance = this
      if (vueInstance.validation(true) == null) {
        addAccountToGroup(vueInstance, vueInstance.user)
        let contactEntity = buildUserRole(vueInstance, true)
        if (vueInstance.roleType == "Delta") {
          vueInstance.deltaContactList.push(contactEntity)
        } else if (vueInstance.roleType == "External") {
          vueInstance.externalContactList.push(contactEntity)
        }
        vueInstance.reset()
        vueInstance.readyUpdate = false
      }
    },
    modify() {
      let vueInstance = this
      if (vueInstance.validation(false) == null) {
        if (vueInstance.roleType == "External") {
          updateExternalUserAccount(vueInstance, {
            username: vueInstance.username,
            email: vueInstance.username,
            name: vueInstance.name,
            jobTitle: vueInstance.jobTitle,
            telephone: vueInstance.telephone,
            lang: vueInstance.getLanguage(),
            enabled: true,
          })
        }
        let oldContactEntity = vueInstance.contactList.find((item, index) => index == vueInstance.updateByRowIndex)
        let contactEntity = buildUserRole(vueInstance, true)
        vueInstance.$set(
          vueInstance.contactList,
          vueInstance.updateByRowIndex,
          Object.assign(oldContactEntity, contactEntity)
        )
        vueInstance.reset()
        vueInstance.readyUpdate = false
      }
    },
    remove() {
      let vueInstance = this
      let selectionListSize = vueInstance.selectionList.length
      if (selectionListSize == 0) {
        return AlertInfo(vueInstance, "請選擇需要刪除的項目")
      }
      AlertDelete(vueInstance, `是否確認要刪除這${selectionListSize}筆項目?`)
        .then(() => {
          let removeIndexArr = []
          vueInstance.selectionList.forEach((selection) => {
            let removeIndex = vueInstance.contactList.findIndex((contact) => contact.uniqueId == selection.uniqueId)
            removeIndexArr.push(removeIndex)
            deleteAccountToGroup(vueInstance, selection.user)
          })
          removeIndexArr.sort((a, b) => b - a)
          removeIndexArr.forEach((removeIndex) => {
            vueInstance.contactList.splice(removeIndex, 1)
          })
        })
        .catch(() => {})
    },
    clickRow(payload) {
      this.reset()
      let vueInstance = this
      vueInstance.readyUpdate = true
      vueInstance.updateByRowIndex = payload.itemIndex

      let item = payload.item
      vueInstance.uniqueId = item.uniqueId
      vueInstance.email = item.adAccount
      vueInstance.name = item.name
      vueInstance.username = item.username
      if (vueInstance.roleType == "Delta") {
        vueInstance.adAccount = item.username
      } else if (vueInstance.roleType == "External") {
        vueInstance.email = item.email
        vueInstance.telephone = item.telephone
        vueInstance.jobTitle = item.jobTitle
      }
      vueInstance.groupAdmin = item.groupAdmin
      vueInstance.originGroupAdmin = item.groupAdmin
      vueInstance.roleArr = []
      vueInstance.roleList.forEach((roleObj) => {
        let value = item[roleObj.name]
        if (value == "Y") {
          vueInstance.roleArr.push(roleObj.code)
          vueInstance.originRoleArr.push(roleObj.code)
        }
      })
      vueInstance.user = item.user
      vueInstance.userId = item.userId
    },
    validationEamil() {
      let vueInstance = this
      if (vueInstance.email.toUpperCase().includes("@DELTAWW.COM") || !CheckEmail(vueInstance.email)) {
        return AlertInfo(vueInstance, vueInstance.email + ": " + this.$t('EMAIL_FORMAT_ERROR') ).then(() => {
          setTimeout(() => vueInstance.$refs['email'].focus(), 200)
        })
      }
      return null 
    },
    validation(isAdd) {
      let vueInstance = this
      let errorMessage = ""
      let ref = ""
      if (vueInstance.roleType == "External") {
        if (!vueInstance.name) {
          errorMessage = errorMessage + vueInstance.$t('KEY_IN_NAME') + " <br>"
          ref = "name"
        }
        if (!vueInstance.telephone) {
          errorMessage = errorMessage + vueInstance.$t('KEY_IN_PHONE') + " <br>"
          ref = "telephone"
        }
        if (!vueInstance.email) {
          errorMessage = errorMessage + vueInstance.$t('KEY_IN_EMAIL') + " <br>"
          ref = "email"
        } else {
          if (!CheckEmail(vueInstance.email)) {
            errorMessage = errorMessage + vueInstance.email + ": " +  vueInstance.$t('EMAIL_FORMAT_ERROR') + " <br>"
            ref = "email"
          }
        }
      } else {
        if (!vueInstance.adAccount) {
          errorMessage = errorMessage + vueInstance.$t('KEY_IN_AD_ACCOUNT') + " <br>"
          ref = "adAccount"
        }
      }
      if (vueInstance.roleArr.length === 0) {
        errorMessage = errorMessage + vueInstance.$t('CHOOSE_AUTHORIZATION') + " <br>"
      }

      if (isAdd) {
        let isExistContact = false
        vueInstance.contactList.forEach((contact) => {
          if (contact.userId == vueInstance.userId) {
            isExistContact = true
          }
        })
        if (isExistContact) {
          errorMessage = errorMessage + vueInstance.$t('REPEAT_CONTACT') + " <br>"
        }
      }

      if (errorMessage) {
        return AlertInfo(vueInstance, errorMessage).then(() => {
          if (ref) {
            setTimeout(() => vueInstance.$refs[ref].focus(), 200)
          }
        })
      } 
      return null
    },
    changeSelection(payload) {
      this.selectionList = payload
    },
    confirmCreateExternalUser() {
      const vueInstance = this
      if (vueInstance.validCreateExternalUser() == null) {
        vueInstance.toggleLoading(true)
        vueInstance.$vendorHttp
          .post(
            "group-account/extusr",
            JSON.stringify({
              username: vueInstance.createEmail.toUpperCase(),
              name: vueInstance.createName,
              jobTitle: vueInstance.createJobTitle,
              telephone: vueInstance.createPhone,
              lang: vueInstance.getLanguage(),
              enabled: true,
            })
          )
          .then((response) => {
            vueInstance.toggleLoading(false)
            vueInstance.readyUpdate = true
            vueInstance.user = response.data
            vueInstance.name = response.data.name
            vueInstance.userId = response.data.id
            vueInstance.username = response.data.username
            vueInstance.telephone = response.data.telephone
            vueInstance.jobTitle = response.data.jobTitle
          })
          .catch(() => {})
      } 
    },
    validCreateExternalUser() {
      let vueInstance = this
      let errorMessage = ""
      let ref = ""
      if (!vueInstance.createEmail) {
        errorMessage = errorMessage + vueInstance.$t('KEY_IN_EMAIL') + " <br>"
      }
      if (!vueInstance.createName) {
        errorMessage = errorMessage + vueInstance.$t('KEY_IN_NAME') + " <br>"
      }
      if (!vueInstance.createPhone) {
        errorMessage = errorMessage + vueInstance.$t('KEY_IN_PHONE') + " <br>"
      }
      if (!vueInstance.createJobTitle) {
        errorMessage = errorMessage + vueInstance.$t('KEY_IN_PHONE') + " <br>"
      }
      if (errorMessage) {
        return AlertInfo(vueInstance, errorMessage).then(() => {
          if (ref) {
            setTimeout(() => vueInstance.$refs[ref].focus(), 200)
          }
        })
      }
      return null
    },
  },
  computed: {
    windowWidth() {
      return this.getWindowsWidth() - 50
    },
    existedContact() {
      return this.contactList.length > 0
    },
    existedDelete() {
      return this.selectionList.length > 0
    },
    canUpdate() {
      let temp = false
      if (this.userType != null && this.userType == "Delta") {
        temp =
          this.getUserProfile().systemFunctions != undefined &&
          this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_CONTACT_PERSON_INFO_AREA_DELTA_MODIFIABLE")
      } else if (this.userType != null && this.userType == "External") {
        temp =
          this.getUserProfile().systemFunctions != undefined &&
          this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_CONTACT_PERSON_INFO_AREA_EXTERNAL_MODIFIABLE")
      }
      return temp
    },
    language() {
      return this.getLanguage()
    },
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  },
  watch: {
    roleType() {
      this.readyUpdate = false
      this.email = ""
      this.adAccount = ""
      if (this.roleType == "External") {
        this.contactList = this.externalContactList
        this.columnsList = this.columnsFrontList.concat(this.columnsNameList, this.columnsDetailList)
      } else if (this.roleType == "Delta") {
        this.contactList = this.deltaContactList
        this.columnsList = this.columnsFrontList.concat(this.columnsNameList, [{
          title: this.$t('EMAIL'),
          key: "email",
          width: 150,
          align: "center",
        }])
      }
    },
    externalContactList() {
      if (this.roleType == "External") {
        this.contactList = this.externalContactList
      }
    },
    deltaContactList() {
      if (this.roleType == "Delta") {
        this.contactList = this.deltaContactList
      }
    },
  },
}

function buildUserRole(vueInstance, isAdd) {
  let contactEntity = {
    uniqueId: isAdd ? uuidv4() : vueInstance.uniqueId,
    roleType: vueInstance.roleType,
    groupAdmin: vueInstance.groupAdmin,
    name: vueInstance.name,
    telephone: vueInstance.telephone,
    email: vueInstance.email,
    userId: vueInstance.userId,
    username: vueInstance.username,
    jobTitle: vueInstance.jobTitle,
    user: vueInstance.user,
  }

  let urlType = vueInstance.user.type == "EXTERNAL_USER" ? "group-account/extusr/" : "group-account/emp/"

  if (vueInstance.groupAdmin == "Y" && vueInstance.originGroupAdmin == "N") {
    vueInstance.$vendorHttp
      .put(urlType + vueInstance.userId + "/role/GROUP_ADMIN")
      .then((response) => {})
      .catch(() => {})
  } else if (vueInstance.groupAdmin == "N" && vueInstance.originGroupAdmin == "Y") {
    vueInstance.$vendorHttp
      .delete(urlType + vueInstance.userId + "/role/GROUP_ADMIN")
      .then((response) => {})
      .catch(() => {})
  }

  vueInstance.roleList.forEach((item) => {
    contactEntity[item.name] = "N"
    if (vueInstance.roleArr.includes(item.code)) {
      contactEntity[item.name] = "Y"
      if (!vueInstance.originRoleArr.includes(item.code)) {
        vueInstance.$vendorHttp
          .put(urlType + vueInstance.userId + "/role/" + item.code)
          .then((response) => {})
          .catch(() => {})
      }
    } else {
      if (vueInstance.originRoleArr.includes(item.code)) {
        vueInstance.$vendorHttp
          .delete(urlType + vueInstance.userId + "/role/" + item.code)
          .then((response) => {})
          .catch(() => {})
      }
    }
  })

  vueInstance.$vendorHttp
    .put(urlType + "oldEc/" + vueInstance.userId + "/role/" + vueInstance.group.uuid, JSON.stringify(vueInstance.roleArr))
    .then((response) => {

    })
    .catch((error) => {
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    })

  return contactEntity
}

function addAccountToGroup(vueInstance, user) {
  vueInstance.toggleLoading(true)
  vueInstance.$vendorHttp
    .put("group-account/" + vueInstance.group.uuid + "/account", JSON.stringify(user))
    .then((response) => {
      vueInstance.toggleLoading(false)
    })
    .catch((error) => {
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    })
}

function updateExternalUserAccount(vueInstance, updateExternalUserAccount) {
  vueInstance.toggleLoading(true)
  vueInstance.$vendorHttp
    .put("group-account/extusr", JSON.stringify(updateExternalUserAccount))
    .then((response) => {
      vueInstance.toggleLoading(false)
    })
    .catch(() => {})
}

function deleteAccountToGroup(vueInstance, user) {
  vueInstance.readyUpdate = false
  vueInstance.toggleLoading(true)
  vueInstance.$vendorHttp
    .delete("group-account/" + vueInstance.group.uuid + "/account/" + user.uuid + '/' + user.type)
    .then((response) => {
      vueInstance.toggleLoading(false)
    })
    .catch(() => {})
}

function searchAccounts(vueInstance) {
  vueInstance.toggleLoading(true)
  vueInstance.contactList = []
  vueInstance.$vendorHttp
    .get("group-account/" + vueInstance.group.uuid + "/accounts")
    .then((response) => {
      vueInstance.toggleLoading(false)
      buildRoles(response.data._embedded.userResourceList, vueInstance)
    })
    .catch(() => {})
}

function buildRoles(accountList, vueInstance) {
  for (let user of accountList) {
    let temp = {
      uniqueId: user.uuid,
      roleType: user.type == "EXTERNAL_USER" ? "External" : "Detla",
      groupAdmin: "N",
      name: user.name,
      email: user.email,
      userId: user.uuid,
      username: user.username,
      adAccount: user.username,
      telephone: user.telephone,
      jobTitle: user.jobTitle,
      user: user,
    }

    if (user.roles) {
      user.roles.forEach((role) => {
        if (role.code.startsWith("GROUP_ADMIN")) {
          temp.groupAdmin = "Y"
        } else {
          let isContactRole = false
          role.attributes.forEach((attribute) => {
            if (attribute.key == "GROUP_PERSON" && attribute.value == "Person") {
              isContactRole = true
            }
          })
          if (isContactRole) {
            temp[role.name] = "Y"
          } else {
            temp[role.name] = "N"
          }
        }
      })
    }
    if (user.type == "EXTERNAL_USER") {
      vueInstance.externalContactList.push(temp)
    } else {
      vueInstance.deltaContactList.push(temp)
    }
  }
}
</script>

<style scoped></style>
